import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

function humanizeLabel(key) {
  const s = key.replace(/_/g, " ").trim();
  return s.charAt(0).toUpperCase() + s.slice(1);
}

// form_data values are Facebook form option slugs, e.g. "just_1–10_(testing/samples)"
// -> "just 1-10 testing samples"
function humanizeValue(value) {
  return String(value)
    .replace(/_/g, " ")
    .replace(/[‐-―]/g, "-")
    .replace(/[()]/g, "")
    .replace(/\//g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function formatFieldValue(value) {
  if (Array.isArray(value)) {
    return value.map(humanizeValue).join(", ");
  }
  return value;
}

function DetailRow({ label, value }) {
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      justifyContent="space-between"
      py={0.75}
      sx={{ borderBottom: "1px solid #f0f0f1" }}
    >
      <Typography sx={{ fontSize: 13, fontWeight: 700, minWidth: 160 }}>
        {label}
      </Typography>
      <Typography sx={{ fontSize: 13, textAlign: "right", wordBreak: "break-word" }}>
        {value != null && value !== "" ? String(value) : "-"}
      </Typography>
    </Box>
  );
}

const FacebookLeadDetailsModal = (props) => {
  const {
    id,
    name,
    email,
    phone_number,
    campaign_name,
    ad_name,
    form_data,
    openModel,
    handleClose,
  } = props;

  const formEntries = form_data ? Object.entries(form_data) : [];

  return (
    <Dialog
      open={openModel}
      onClose={handleClose}
      aria-labelledby="facebook-lead-details-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="facebook-lead-details-title">
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography sx={{ fontSize: 18, fontWeight: 700 }}>
            Facebook Lead #{id}
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Box mb={3}>
          <DetailRow label="Name" value={name} />
          <DetailRow label="Email" value={email} />
          <DetailRow label="Phone" value={phone_number} />
          <DetailRow label="Campaign Name" value={campaign_name} />
          <DetailRow label="Ad Name" value={ad_name} />
        </Box>

        <Typography sx={{ fontSize: 15, fontWeight: 700, mb: 1 }}>
          Form Responses
        </Typography>
        {formEntries.length > 0 ? (
          formEntries.map(([key, value]) => (
            <DetailRow
              key={key}
              label={humanizeLabel(key)}
              value={formatFieldValue(value)}
            />
          ))
        ) : (
          <Typography sx={{ fontSize: 13, color: "#757575", mb: 2 }}>
            No form responses available.
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default FacebookLeadDetailsModal;
